// @ts-nocheck
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
// Tambahkan modul ke Swiper
Swiper.use([Autoplay, Navigation, EffectFade, Pagination]);

export function initSwiper() {
    var sliderDestination = new Swiper(".slider-destination", {
        slidesPerView: 1.3,
        slidesOffsetBefore: 30,
        spaceBetween: 20,
        loop: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".nav-slider-destination .btn-next",
            prevEl: ".nav-slider-destination .btn-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
                loop: false,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 20,
                slidesOffsetBefore: 0,
                loop: false,
            },
        },
    });

    var sliderPackages = new Swiper(".slider-packages", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        slidesOffsetBefore: 30,
        loop: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".container-slider-packages .btn-next",
            prevEl: ".container-slider-packages .btn-prev",
        },
    });

    var sliderActivity = new Swiper(".slider-activity", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        slidesOffsetBefore: 30,
        loop: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".container-slider-packages .btn-next",
            prevEl: ".container-slider-packages .btn-prev",
        },
    });

    var sliderTickets = new Swiper(".slider-tickets", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        slidesOffsetBefore: 30,
        loop: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".container-slider-packages .btn-next",
            prevEl: ".container-slider-packages .btn-prev",
        },
    });

    var sliderReview = new Swiper(".slider-review", {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".container-slider-review .btn-next",
            prevEl: ".container-slider-review .btn-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
        },
    });

    var sliderPackages2 = new Swiper(".slider-tour-packages-2", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        slidesOffsetBefore: 30,
        breakpoints: {
            640: {
                slidesPerView: 1.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1,
                slidesPerView: 2.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 4.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
        },
    });

    var sliderActivities2 = new Swiper(".slider-activities-2", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        slidesOffsetBefore: 30,
        breakpoints: {
            640: {
                slidesPerView: 1.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1,
                slidesPerView: 2.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 4.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
        },
    });

    var sliderTicket2 = new Swiper(".slider-tickets-2", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        slidesOffsetBefore: 30,
        breakpoints: {
            640: {
                slidesPerView: 1.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1,
                slidesPerView: 2.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 4.3,
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            },
        },
    });
}

